module.exports = __webpack_public_path__ + "static/media/fexco.95655bc4.png";